import {
  EntityInEstateStatus,
  NonTrustEntityTaxStatus,
  TrustTaxStatus,
} from '@/types/schema';

import { TaxDrag_EntityFragment } from './TaxDrag.generated';
import { TaxDragEntity } from './TaxDrag.types';

const TAX_STATUS_LABELS = {
  [TrustTaxStatus.GrantorTrust]: 'Grantor',
  [TrustTaxStatus.NonGrantorTrust]: 'Non-grantor',
  [TrustTaxStatus.NonTaxableTrust]: 'Non-taxable',
  [NonTrustEntityTaxStatus.Taxable]: 'Taxable',
  [NonTrustEntityTaxStatus.NonTaxable]: 'Non-taxable',
};

export function getTaxDragEntityDescription(entity: TaxDragEntity): string {
  const taxStatus = entity.taxStatus ? TAX_STATUS_LABELS[entity.taxStatus] : '';
  const estateStatus = {
    [EntityInEstateStatus.InEstate]: 'in estate',
    [EntityInEstateStatus.OutOfEstate]: 'out of estate',
  };
  return [
    taxStatus,
    entity.inEstateStatus ? estateStatus[entity.inEstateStatus] : '',
  ]
    .filter(Boolean)
    .join(' - ');
}

export function mapTaxDragEntity(
  entity: TaxDrag_EntityFragment
): TaxDragEntity {
  const { subtype } = entity;
  const inEstateStatus =
    'taxDragInEstateStatus' in subtype
      ? subtype.taxDragInEstateStatus
      : undefined;
  const stateInEstateStatus =
    'taxDragStateInEstateStatus' in subtype
      ? subtype.taxDragStateInEstateStatus
      : undefined;

  let taxStatus: TaxDragEntity['taxStatus'];
  if ('taxDragTrustStatus' in subtype) {
    taxStatus = subtype.taxDragTrustStatus;
  } else if ('taxDragNonTrustStatus' in subtype) {
    taxStatus = subtype.taxDragNonTrustStatus;
  }

  return {
    id: entity.id,
    displayName: subtype.displayName,
    kind: entity.kind,
    stage: entity.stage,
    currentValue: subtype.currentValue,
    inEstateStatus,
    stateInEstateStatus,
    taxStatus,
  };
}
